<template>
  <ValidationProvider :rules="{ required: required }" slim v-slot="{ failed, passed, validate, errors }">
    <div :class="fieldClassList({ failed, passed, validate, value: text })" class="lib__field">
      <label class="lib__field__label">{{ label }}</label>
      <div class="lib__field__select lib__field__select--custom">
        <Selector tag="ul" v-model="text" v-slot="{ currentValue, setValue }">
          <li
            :class="{ 'lib__field__select__item--active': currentValue === option.value }"
            :data-cy="currentValue === option.value && 'selected'"
            :data-value="`${option.value}`"
            :key="option.value"
            @click="setValue(option.value)"
            v-for="option in options"
          >
            {{ option.text }} A
            <span class="lib__field__select__annexe">{{ $t('meter.powerCustom', { kva: getKva(tension, option.value) }) }}</span>
          </li>
        </Selector>
      </div>
      <error-message :error="errors[0]" />
    </div>
  </ValidationProvider>
</template>

<script lang="ts">
import { Vue, Inject, Prop, Emit, Component } from 'vue-property-decorator'
import { meterService } from '@/services'
import { MeterElectricityTension } from '@/models'
import { FieldMixin } from '@ores/vue-library';
import { mixins } from 'vue-class-component';

@Component
export default class PowerSelectBox extends mixins(FieldMixin) {
  //#region [Property]
  @Prop({ type: [String, Number], default: null }) public readonly value!: string | null
  @Prop({ type: String, default: null }) public readonly label!: string | null
  @Prop({ type: Array, required: true })
  public readonly options!: Array<{ text: string; value: string; disabled?: boolean }>
  @Prop({ type: String, required: true }) public tension!: MeterElectricityTension
  @Prop({ type: Boolean, default: false }) public readonly required!: boolean
  //#endregion

  //#region [Computed]
  public get text(): string | null {
    return this.value
  }
  public set text(value: string | null) {
    this.change(value)
  }
  //#endregion

  //#region [Method]
  public getKva(tension: MeterElectricityTension, intensity: string) {
    return meterService.getPower(tension, +intensity)
  }
  //#endregion

  //#region [Emit]
  @Emit('input')
  public change(value: string | null): string | null {
    return value
  }
  //#endregion
}
</script>
